import { Controller } from '@hotwired/stimulus';
import { convertToCurrency } from './currency';

export default class extends Controller {
  static targets = ['amount', 'fees', 'total'];

  connect() {
    this.#render(0);
  }

  update(event) {
    this.#render(event.detail.amount);
  }

  #render(amount) {
    const fees = 0;
    const total = amount + fees;

    this.amountTarget.textContent = convertToCurrency(amount);
    this.feesTarget.textContent = convertToCurrency(fees);
    this.totalTarget.textContent = convertToCurrency(total);
  }
}
